import Layout from "../../components/Layout/Layout";
import { Link } from 'react-router-dom';
import React, { useState } from 'react'
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { PlusCircleIcon } from "@heroicons/react/outline";
import { useEffect, Fragment } from 'react';
import RoleServices from '../../services/RoleServices'
import ActionDropdown from "../../components/ActionDropdown";
import Paginate from "../../utils/Paginate";


export default function Roles() {


    const [roles, setRole] = useState([])
    const [search, setSearch] = useState("")
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false);
    const [pageLength, setPageLength] = useState("")

    const listRole = async () => {
        const getRoles = await RoleServices.listRoles(pageIndex, 10, search);
        setRole([...getRoles.data.result]);
        setPageLength([...getRoles.data.result].length);
        setPageNumber(getRoles.data.totalCount);
        setPageIndex(getRoles.data.pageIndex);
        setPrev(getRoles.data.hasPreviousPage);
        setPage(getRoles.data.totalPages);
        setNextPage(getRoles.data.hasNextPage)
    }
    const searchRole = async (text) => {
        const result = (await RoleServices.listRoles(pageIndex, 10, text)) || []
        setRole([...result.data.result])
        setPageNumber(1);
        setSearch(text);
    }
    useEffect(() => {
        listRole();
    }, [pageIndex])
    return (<>
        <Layout title="User Management" pageTag={"admin"} current={'/users'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                    <div className="flex">
                                        <div className="mt-1 relative rounded-md shadow-sm">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            </div>
                                            <input
                                                type="text"
                                                name="user"
                                                id="user"
                                                onChange={(e) => searchRole(e.target.value)}
                                                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                                placeholder="Search roles"
                                            />
                                            <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                                <div className='tooltip'>
                                                    <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                                    <span className="tooltiptext"> <p>Search by role name and module assigned</p></span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                </div>

                                <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">

                                    <Link to="/create/role">
                                        <button
                                            type="button"
                                            className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                        >
                                            <PlusCircleIcon className="w-4 mr-1.5" />
                                            Create New Role
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            {roles.length === 0 ? (
                                <div className="alert alert-warning mt-8"> No data available for these dates to show. </div>
                            ) :  <>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle">
                                        <div className="relative ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                            <table className="min-w-full table-fixed divide-y divide-gray-300 ">
                                                <thead>
                                                    <tr>

                                                        <th scope="col" className="min-w-[9rem] py-3.5 pl-5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                            Name
                                                        </th>
                                                        <th scope="col" className="min-w-[6rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Modules Available
                                                        </th>
                                                        <th scope="col" className="px-2 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Number of Users
                                                        </th>

                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">

                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            <span className="sr-only">Edit</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {roles.map((person, i) => (
                                                        <tr key={i} >
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.roleName}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 ">{person.moduleAssigned}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.emailAddress}</td>
                                                            <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                <ActionDropdown
                                                                  items={[
                                                                    { label: "Update Role", onClick: () => window.location.href = `/update/role?id=${person.roleName}` },
                                                                  ]}
                                                                  dropdownWidth="w-40"
                                                                />

                                                            </td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                        </> }
                          

                        </div>
                    </div>
                </main>

            </React.Fragment>
        </Layout>

    </>);
}